import React, { Component } from 'react'
import './styles.css'
import ToolTip from '../ToolTip'
import { Trans } from 'react-i18next'
import PropTypes from 'prop-types'
import { constants } from '../../../constants'

class Score extends Component {

  render () {
    if (this.props.type === 'small') {
      return (
        <div className="Score ">
          <div className="Score-Holder">
            <div className={'Score-Bar Score-Bar-' + this.props.id + ' ToolTip-Handle'}
                 style={{ width: (this.props.percentage * 100) + '%' }}>
              <ToolTip><Trans>{constants.scores.types[this.props.id].name}</Trans></ToolTip>
            </div>
          </div>
        </div>
      )
    } else if (this.props.type === 'large') {
      return (
        <div className="Score Score-Large">
          <div className="Score-Holder">
            <div className={'Score-Bar Score-Bar-' + this.props.id}
                 style={{ width: (this.props.percentage * 100) + '%' }}>
              <span>{this.props.label}</span>
            </div>
          </div>
        </div>
      )
    }
  }
}

Score.defaultProps = {
  type: 'small'
}

Score.propTypes = {
  id: PropTypes.number.isRequired,
  percentage: PropTypes.number.isRequired,
  type: PropTypes.string,
  label: PropTypes.string
}

export default Score
